import { LOCAL_STORAGE_KEY } from './config';

const langMap = {
  en: 'en',
  fr: 'fr',
  de: 'de',
  it: 'it',
  es: 'es',
};

export const getLanguage = (): string | undefined => {
  const lang = location.pathname.replace(/^\/+/g, '').split('/')[0];

  // TODO: refactor without type assertion, or add comment
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return langMap[lang as keyof typeof langMap];
};

export const getLanguageWithFallback = (): string =>
  getLanguage() || langMap.en;

export const getLanguageKey = (): string | undefined => {
  const langKey = getLanguage();
  const region = ENVIRONMENT_REGION || 'US';

  if (langKey && langKey !== undefined && region) {
    return `${langKey}-${region}`;
  }

  const localData = window.localStorage.getItem(LOCAL_STORAGE_KEY);

  if (localData && region) {
    const localDataLang = JSON.parse(localData)?.lang?.locale;

    // TODO: refactor without type assertion, or add comment
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (langMap[localDataLang as keyof typeof langMap]) {
      return `${localDataLang}-${region}`;
    }
  }

  return 'en-US';
};
